import { errMessage } from "./errMessage";

export function mapTypedError<T>(
  e: unknown,
  byCode: Record<string, (message: string | undefined) => T>,
  fallback?: (e: unknown) => T,
): T {
  const code = (e as { code?: string })?.code;
  const handler = code ? byCode[code] : undefined;
  if (handler) {
    return handler(errMessage(e));
  }
  if (fallback) {
    return fallback(e);
  }
  throw e;
}
